export default __webpack_public_path__ + "static/media/extension.c90f4b59.svg";